import { msRopcApiWraper, msRopcClient } from './ms-ropc-client'
import { smartSwiftApiWraper, smartSwiftClient } from './smart-swift-client'
import { createMethod } from './tools'

export const api = {
  smartSwift: createMethod(smartSwiftClient, smartSwiftApiWraper),
  msRopc: createMethod(msRopcClient, msRopcApiWraper),
}
